import axios from 'axios'

var cache;
export default async function() {
  if (!cache) {
    var json = await axios.get(process.env.VUE_APP_BACKEND_URL + 'data/fiches');
    cache = json.data;
  }
  return cache
}
